export const BUILD_VERSION = '1775226578';
